<template>
  <div class="p-d-flex p-ai-center">
    <CurrencyValue
      :currency="currencyIso"
      v-if="Number.isFinite(value) && currencyIso && !isValuationTypePercentage"
      :decimal="decimal"
    >
      {{ value }}
    </CurrencyValue>
    <PercentageValue v-else-if="isValuationTypePercentage" :value="value" />
    <strong class="unit" v-else-if="Number.isFinite(value)">{{ commaNumber(value, "'") }}</strong>
    <div class="currency-value not-available" v-else-if="!loading">N/A</div>
    <VestrIndicator
      :hasVestr="hasVestr"
      customClass="p-ml-2"
    />
  </div>
  <Date
    v-if="showDate && date"
    dateColor="var(--secondary-color-light-alpha)"
    size="small"
    :inline="false"
  >
    {{ date }}
  </Date>
  <Skeleton v-if="loading" width="8ch" height="1.25em" />
</template>

<script>
import Skeleton from "primevue/skeleton";
import CurrencyValue from "@/components/elements/CurrencyValue";
import Date from "@/components/elements/Date";
import commaNumber from "comma-number";
import { ValuationTypeEnum } from "../product/Types";
import PercentageValue from "@/components/elements/PercentageValue";
import Tooltip from "primevue/tooltip";
import VestrIndicator from "@/components/elements/VestrIndicator";

export default {
  name: "Valuation",
  components: {
    CurrencyValue,
    Date,
    Skeleton,
    PercentageValue,
    VestrIndicator,
  },
  directives: {
    tooltip: Tooltip,
  },
  props: {
    value: Number,
    date: String,
    currencyIso: String,
    showDate: {
      type: Boolean,
      default: true,
    },
    loading: Boolean,
    decimal: {
      type: Number,
      default: 2,
    },
    valuationTypeId: Number,
    hasVestr: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    commaNumber,
  },
  computed: {
    isValuationTypePercentage() {
      return this.valuationTypeId == ValuationTypeEnum.Percentage;
    },
  },
};
</script>

<style scoped lang="scss">
.not-available {
  min-width: 3char;
  line-height: 1;
}
.unit {
  line-height: 1;
}

</style>
